// Funciones de lógica del quiz que pueden ser reutilizadas en diferentes componentes

// Función para ordenar preguntas por dificultad (fácil, media, difícil)
export const ordenarPreguntasPorDificultad = (preguntas) => {
  // Separar preguntas por dificultad
  const preguntasFaciles = [];
  const preguntasMedias = [];
  const preguntasDificiles = [];
  
  preguntas.forEach(pregunta => {
    const dificultad = pregunta.dificultad ? pregunta.dificultad.toLowerCase() : '';
    if (dificultad.includes('facil') || dificultad.includes('fácil')) {
      preguntasFaciles.push(pregunta);
    } else if (dificultad.includes('medio') || dificultad.includes('media')) {
      preguntasMedias.push(pregunta);
    } else if (dificultad.includes('dificil') || dificultad.includes('difícil')) {
      preguntasDificiles.push(pregunta);
    } else {
      // Si no tiene dificultad definida, por defecto se considera media
      preguntasMedias.push(pregunta);
    }
  });
  
 // Combinar preguntas en orden: fáciles, medias, difíciles
  return [...preguntasFaciles, ...preguntasMedias, ...preguntasDificiles];
};

// Función para mezclar aleatoriamente un array
export const mezclarArray = (array) => {
  const arrayCopia = [...array];
  for (let i = arrayCopia.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arrayCopia[i], arrayCopia[j]] = [arrayCopia[j], arrayCopia[i]];
  }
  return arrayCopia;
};

// Función para calcular el índice de la respuesta correcta
export const calcularIndiceRespuestaCorrecta = (respuestasMezcladasPreguntaActual) => {
  return respuestasMezcladasPreguntaActual.findIndex(respuesta => respuesta.esCorrecta);
};

// Función para obtener respuestas mezcladas con atributos de corrección
export const obtenerRespuestasMezcladas = (pregunta) => {
  // Si las respuestas ya vienen con el atributo 'verdadero' desde la API
  if (pregunta.respuestas_mezcladas && pregunta.respuestas_mezcladas.length > 0) {
    // Mantener el atributo 'verdadero' original y convertirlo a 'esCorrecta' para mantener la consistencia con el resto del código
    return pregunta.respuestas_mezcladas.map(respuesta => ({
      texto: respuesta.texto,
      verdadero: respuesta.verdadero, // Atributo binario explícito
      esCorrecta: respuesta.verdadero,
      indiceOriginal: respuesta.verdadero ? 0 : (pregunta.respuesta_falsa1 === respuesta.texto ? 1 : (pregunta.respuesta_falsa2 === respuesta.texto ? 2 : 3))
    }));
  } else {
    // Para mantener compatibilidad, si no vienen con el nuevo formato
    const respuestasParaMezclar = [
      { texto: pregunta.respuesta_correcta, verdadero: true, esCorrecta: true, indiceOriginal: 0 },
      { texto: pregunta.respuesta_falsa1, verdadero: false, esCorrecta: false, indiceOriginal: 1 },
      { texto: pregunta.respuesta_falsa2, verdadero: false, esCorrecta: false, indiceOriginal: 2 },
      { texto: pregunta.respuesta_falsa3, verdadero: false, esCorrecta: false, indiceOriginal: 3 }
    ];
    return mezclarArray(respuestasParaMezclar);
  }
};

// Función para inicializar todas las respuestas mezcladas para todas las preguntas
export const inicializarRespuestasMezcladas = (preguntas) => {
 return preguntas.map(pregunta => obtenerRespuestasMezcladas(pregunta));
};
